import $ from "jquery";

if (document.getElementsByClassName('thank-you-page').length){
    if (!document.querySelector('.thank-you-page.thank-you-page--lp')) {
        var thankYoucolours = ['#00ffb0', '#ff917f', '#5fd4ff'];
        var randomColour = Math.floor(Math.random() * thankYoucolours.length);
        var selectedColour = thankYoucolours[randomColour];
        $('.thank-you-page').css('background-color', selectedColour);
    }
}


$('.project-header__floating-shapes span').each(function(){
    var spanTopPosition = $(this).css('top');
});

// window.addEventListener('scroll', function() {
//     console.log(window.scrollY);
// });

// Make Wistia use privacy mode by default
window._wq = window._wq || [];
window._wq.push(function (W) {
    W.consent(false);
    // console.log('Wistia consent? ' + W.consent());
});

// $(document).ready(function(){
//     document.addEventListener('aos:in', ({ detail }) => {
//         console.log('animated in', detail);
//     });

//     document.addEventListener('aos:out', ({ detail }) => {
//         console.log('animated out', detail);
//     });
// });

if (document.getElementsByClassName('quiz-wrapper').length && !document.getElementsByClassName('multiple-choice-quiz').length) {

// Jargon Quiz

console.log("jargon quiz js loaded")

var jargonQuizSettings = {
    "quiz_name": "Motum Buzzword Quiz",
    "current_question":1,
    "current_score":0
}

const jargonQuizResults = [
    {
        "stub":"disruptor",
        "title":"You're a Disruptor!",
        "subtitle": "You reject the status quo!",
        "image":"/images/interface/buzzword-quiz/result_disruptor-2.gif",
        "text":"<p>You didn’t get very many correct answers, but you’re a winner in our books. If we’re being honest, you’re much better off excluding these terms from your marketing vocabulary. </p><p>After all, there’s one big issue underlying all of these marketing terms — besides how silly they might sound or look on paper — and it’s one of communication. What do these terms really mean? What value do they add to your content, your reports, or even your internal discussions?</p><p>Even with the best intentions, bad marketing jargon can come across as unspecific and hollow, obscuring the core of your message and alienating your audience.</p><p><strong>Tips for Disruptors:</strong> You can use that rebellious attitude to your advantage. Your marketing lexicon is a guideline, not a rule, so focus on using a varied vocabulary and play to your creative strengths.</p>",
        "share_message": "I'm a buzzword Disruptor!",
        "required_score":[0,1,2]
    },
    {
        "stub": "sherpa",
        "title":" You’re a Sherpa!",
        "subtitle": "Like a wise Sherpa guiding your followers through the Himalayas, you know your way around a quiz.",
        "image":"/images/interface/buzzword-quiz/result_sherpa-2.gif",
        "text":"<p>You did pretty well, but you haven’t fully assimilated into the world of marketing jargon. And we don’t blame you! </p><p>After all, there’s one big issue underlying all of these marketing terms — besides how silly they might sound or look on paper — and it’s one of communication. What do these terms really mean? What value do they add to your content, your reports, or even your internal discussions?</p><p>Even with the best intentions, bad marketing jargon can come across as unspecific and hollow, obscuring the core of your message and alienating your audience.</p><p><strong>Tips for Sherpas:</strong> You still have the chance to stray from the flock (in a good way). If you can balance specific language with outside-the-box thinking, you’ll be well on your way to creating more valuable and engaging content.</p>",
        "share_message": "I'm a buzzword Sherpa!",
        "required_score":[3,4,5]
    },
    {
        "stub":"envisioneer",
        "title":"You’re an Envisioneer!",
        "subtitle": "Welcome to the Machine.",
        "image":"/images/interface/buzzword-quiz/result_envisioneer-2.gif",
        "text":"<p>You’re a full-blown Envisioneer, ready to ideate holistic innovations til the cows come home! Though we’re proud of you for being so well-versed in modern marketing lingo, we encourage you to use that creative mind for good instead of evil. </p><p>After all, there’s one big issue underlying all of these marketing terms — besides how silly they might sound or look on paper — and it’s one of communication. What do these terms really mean? What value do they add to your content, your reports, or even your internal discussions?</p><p>Even with the best intentions, bad marketing jargon can come across as unspecific and hollow, obscuring the core of your message and alienating your audience.</p><p><strong>Tips for Envisioneers:</strong> Do you say “innovative” a lot, or struggle to find synonyms for “solutions”? Find your go-to words and challenge yourself to write content without using them at all. You might find that your content gets more descriptive, and more valuable to readers, as a result.</p>",
        "share_message": "I'm a buzzword Envisioneer!",
        "required_score":[6,7]
    }
]


const jargonQuizQuestions = [
    {
        "question":"The blending of digital and physical experiences is known as the <span class='answer-spot'><span class='user-answer'>&nbsp;</span><span class='correct-answer'>phygital</span></span> world.",
        "answers": [
            {
                "letter":"A",
                "normal":"Phygital",
                "cased":"phygital"
            },
            {
                "letter":"B",
                "normal":"Digical",
                "cased":"digical"
            },
            {
                "letter":"C",
                "normal":"Digimon",
                "cased":"Digimon"
            },
            {
                "letter":"D",
                "normal":"Virtual Reality",
                "cased":"virtual reality"
            },
        ],
        "response_wrong":"<p>Good guess, but the right answer is phygital, which is also the name of a parasite that lives in your nasal cavity. Actually, maybe it’s a new weight loss fad (The Phygital Diet: Just Giblets and Figs). Or a widget for phytoplankton...?</p><p>Anyway, whatever — “phygital” actually refers to the merging of physical and digital spheres.</p>",
        "response_correct": "<p>Bet you didn’t expect to be right on this one! When the digital and physical spaces meet, you get the phygital world.</p>",
        "response_both": "<p>“Phygital”comes across like an ultramodern hybrid term, which, along with the rapid evolution of artificial intelligence, is probably a sign that we are on track to an apocalyptic future ruled by machines where only Keanu Reeves can free us with jujitsu and buckets of bullets.</p><p>Anyway, there may be something to it, <a href='https://www.cmo.com.au/article/614892/why-it-time-brands-got-more-phygital-customer-experience/' target='_blank'>so here’s a link explaining what’s going on.</a></p>",
        "alternative_terms": "It doesn’t matter, because you never need to say “phygital.”",
        "current_answer": 0,
        "correct_answer": 0,
        "score": 0
    },
    {
        "question":"This person downright worships your brand. As an independent influencer who touts the merits of your products to anyone who will listen, both online and offline, this person is called a <span class='answer-spot'><span class='user-answer'>&nbsp;</span><span class='correct-answer'>brand evangelist</span></span>.",
        "answers": [
            {
                "letter":"A",
                "normal":"Fanboy or Fangirl",
                "cased":"fanboy or fangirl"
            },
            {
                "letter":"B",
                "normal":"Baritone Trumpeter",
                "cased":"baritone trumpeter"
            },
            {
                "letter":"C",
                "normal":"Contortionist",
                "cased":"contortionist"
            },
            {
                "letter":"D",
                "normal":"Brand Evangelist",
                "cased":"brand evangelist"
            }
        ],
        "response_wrong":"<p>Sorry, but they’re actually called brand evangelists. They latch onto your brand like alien symbiotes and broadcast your message to the social media hivemind.</p>",
        "response_correct": "<p>Nice! You can always count on a brand evangelist to generate a positive buzz about your products. All it takes is two hymns, three Hail Marys and a quick selfie with the Juno filter.</p>",
        "response_both": "<p>How do you get brand evangelists?</p><p>It starts with brand baptism, then brand communion, and when your business is ready to die for our sins, brand crucifixion.</p>",
        "alternative_terms": "Unless Joan of Arc comes back to life and starts a Twitter campaign to promote her autobiography, there’s no reason to conflate religion with marketing. Terms like “supporter” and “fan” both work fine.",
        "current_answer": 0,
        "correct_answer": 3,
        "score": 0
    },
    {
        "question":"These enlightened few know how to unlock your business’ potential with a balance of age-old wisdom and modern marketing chops. They are called <span class='answer-spot'><span class='user-answer'>&nbsp;</span><span class='correct-answer'>marketing gurus</span></span>.",
        "answers": [
            {
                "letter":"A",
                "normal":"Marketing Yogis",
                "cased":"marketing yogis"
            },
            {
                "letter":"B",
                "normal":"Marketing Gurus",
                "cased":"marketing gurus"
            },
            {
                "letter":"C",
                "normal":"Marketing Yodas",
                "cased":"marketing Yodas"
            },
            {
                "letter":"D",
                "normal":"Marketing Sages",
                "cased":"marketing sages"
            }
        ],
        "response_wrong":"<p>Well, no. Marketing gurus, sometimes called Sherpas, are self-proclaimed marketing masters who promise to jumpstart your business’ growth with their arcane secrets and the steel bracelets they sell to demagnetize your aura. </p>",
        "response_correct": "<p>Nicely done. Marketing gurus, or Sherpas, share their wisdom with flocks of aspiring marketers. For an extra ten rupees they’ll play a Tibetan singing bowl painted in the colour of your chakra.</p>",
        "response_both": "<p>Historically, gurus were religious teachers who passed down knowledge of ancient Hindu concepts like spiritual ascension, dispelling darkness, and, uh, improving your SEO apparently.</p><p>Modern gurus like to capitalize on their tenuous connection to historical religious figures, which is why they can charge unholy sums of money for marketing insights you could’ve read on <a href='https://www.marketingweek.com' target='_blank'><em>Marketing Week.</em></a></p>",
        "alternative_terms": "A marketing expert. An established, professional marketer who knows a lot about the biz. Or, you know, someone with a Master’s in Marketing. Literally anything but “guru.”",
        "current_answer": 0,
        "correct_answer": 1,
        "score": 0
    },
    {
        "question":"As content proliferates faster and in larger quantities across a wide variety of channels, marketing content creators use <span class='answer-spot'><span class='user-answer'>&nbsp;</span><span class='correct-answer'>snackable content</span></span> to keep hold of reader attention spans.",
        "answers": [
            {
                "letter":"A",
                "normal":"Content microcosms",
                "cased":"content microcosms"
            },
            {
                "letter":"B",
                "normal":"Snackable content",
                "cased":"snackable content"
            },
            {
                "letter":"C",
                "normal":"Popcorn with Smarties sprinkled on top",
                "cased":"popcorn with Smarties sprinkled on top"
            },
            {
                "letter":"D",
                "normal":"Ritalin injections",
                "cased":"Ritalin injections"
            }
        ],
        "response_wrong":"<p>That sounds awesome, but the answer is snackable content. Apparently, we only have so much room in our tiny brain-bellies, so content needs to be brief, unfulfilling and coated in Cheeto crumbs.</p>",
        "response_correct": " <p>Yum. The term snackable content means putting your audience on a diet so they don’t store any of the information they read as “mental fat.”</p>",
        "response_both": "<p>“Snackable content” perfectly encapsulates the idea of short and sweet content, probably necessary in this day of mobile phone addiction. But we wouldn’t recommend only publishing snackable content.</p><p>Instead, think of your content strategy as an entire meal: appetizer, main course, and tasty dessert. And hey, there’s nothing saying you can’t create a nutritious appetizer.</p>",
        "alternative_terms": "“Short-form content.” Boring but completely satisfying.",
        "current_answer": 0,
        "correct_answer": 1,
        "score": 0
    },
    {
        "question":"When you truly become a trailblazer of innovative marketing ideas, you will earn the title <span class='answer-spot'><span class='user-answer'>&nbsp;</span><span class='correct-answer'>envisioneer</span></span>.",
        "answers": [
            {
                "letter":"A",
                "normal":"Envisioneer",
                "cased":"envisioneer"
            },
            {
                "letter":"B",
                "normal":"Ideomancer",
                "cased":"ideomancer"
            },
            {
                "letter":"C",
                "normal":"Imaginaut",
                "cased":"imaginaut"
            },
            {
                "letter":"D",
                "normal":"Idea Wizard",
                "cased":"idea wizard"
            }
        ],
        "response_wrong":"<p>All four answers are awful and bankrupt of meaning, but no, we were looking for envisioneer. They come up with pioneering ideas and use their vision to boost business...</p>",
        "response_correct": "<p>Did you pick the one that made you gag the most? Whatever you did, it worked! An envisioneer is like a pioneer of envisioning unique new business ideas...</p>",
        "response_both": "<p>...or something. To be honest, we’re not exactly sure what an envisioneer is supposed to be, but we know it defies logic and sounds simultaneously pretentious and absurd.</p><p>If you really want to watch the world burn, turn it into a verb, as in, “Dilbert envisioneered a necktie that will never lie flat.”</p>",
        "alternative_terms": "Just stop talking.",
        "current_answer": 0,
        "correct_answer": 0,
        "score": 0
    }, {
        "question":"Cross an article with a chart and you get <span class='answer-spot'><span class='user-answer'>&nbsp;</span><span class='correct-answer'>charticle</span></span>.",
        "answers": [
            {
                "letter":"A",
                "normal":"Art",
                "cased":"art"
            },
            {
                "letter":"B",
                "normal":"Artichart",
                "cased":"artichart"
            },
            {
                "letter":"C",
                "normal":"AARDVARK",
                "cased":"aardvark"
            },
            {
                "letter":"D",
                "normal":"Charticle",
                "cased":"charticle"
            }
        ],
        "response_wrong":"<p>No, but don’t sweat it; all of these answers are equally revolting. We didn’t really expect you to know that an article crossed with a chart makes a charticle.</p>",
        "response_correct": "<p>Yup. Article + chart = charticle. Easily confused with “chart,” “article,” and “barf-in-your-mouth-ticle.”</p>",
        "response_both": "<p>Much like its cousin “listicle,” the term “charticle” serves no purpose other than to confuse readers and inflict other marketers with existential dread.</p><p>There’s also a slippery slope argument to be had: if you’re going to use charticle, what’s stopping you from making an artigraph (graph+article) or a vennticle (article+venn diagram)? Or a <em>Paul Blarticle: Mall Chart</em> (self-explanatory)?</p>",
        "alternative_terms": "NO.",
        "current_answer": 0,
        "correct_answer": 3,
        "score": 0
    },
    {
        "question":"You need to work on your brand image: make it more appealing and identifiable to your customers, and fine-tune your message. You need to engage in <span class='answer-spot'><span class='user-answer'>&nbsp;</span><span class='correct-answer'>brandscaping</span></span>.",
        "answers": [
            {
                "letter":"A",
                "normal":"Brandscaping",
                "cased":"brandscaping"
            },
            {
                "letter":"B",
                "normal":"Spring cleaning",
                "cased":"spring cleaning"
            },
            {
                "letter":"C",
                "normal":"Brand makeovers",
                "cased":"brand makeovers"
            },
            {
                "letter":"D",
                "normal":"Roomba drag racing",
                "cased":"Roomba drag racing"
            }
        ],
        "response_wrong":"<p>Unfortunately, the right answer is brandscaping, which means something about aerating the AstroTurf in your office mini-putt room, or whatever. If we had to rate this term on a scale of one (hot, steaming fertilizer) to ten (bird-shaped topiary), we would give it a bag of discarded lawn clippings.</p>",
        "response_correct": "<p>Way to go! The act of brandscaping involves trimming and watering and prettifying, which are all verbs that have to do with taking care of your lawn.</p> ",
        "response_both": "<p>“Brandscaping” is great because it totally covers anything you might want to do with your brand, to the point where the term is nearly useless to you. </p><p>Are you renovating your storefront? Partnering with other brands? Trimming the hedges out front? Brandscaping means all of those things, and nothing.</p>",
        "alternative_terms": "Rebranding, revising your messaging, or whatever you are specifically doing.",
        "current_answer": 0,
        "correct_answer": 0,
        "score": 0
    },
]

console.log(jargonQuizQuestions);

const progressBarContents = `

   <span class="progress-bar__indicator">
       <span class="progress-bar__counter">
           <span>1</span>/<span>2</span>
       </span>
   </span>
        <div class="progress-bar-points">
            <!-- Progress bar points go here -->

    ${jargonQuizQuestions.map((question, index) =>
    `
        <span class="progress-bar-point"><span class="progress-bar-point__answer">${question.answers[question.correct_answer].normal}</span></span>
    `
    ).join('')}
      </div>
    `;

const markup = `
    ${jargonQuizQuestions.map((question, index) =>
        `
    <div class="question" index="${index}">
        <div class="question__content">
            <span class="question__subtitle">
                <span>
                    <span class="question-num">Question ${index + 1}</span>
                    <span class="question-correct">Nailed it!</span>
                    <span class="question-wrong">Nope :(</span>
                </span>
            </span>
            <h2 class="question__title">${question.question}</h2>
            <div class="answers">
            ${question.answers.map((answer, index) => `
                <div class="answer-container">
                  <button class="answer" index="${index}"><span>${answer.normal}</span><span class="cased-answer"><span>${answer.cased}</span></span></button>
                   <div class="question__submit">
                    <button class="btn__submit-answer js-submit-answer"><span></span>Lock it in!<i class="icon-arrow-right"></i></button>
                   </div>
                </div>

            `).join('')}
            </div>

                <div class="question-responses">
            <div class="question-response correct">
                ${question.response_correct}
            </div>
             <div class="question-response wrong">
                ${question.response_wrong}
             </div>

            <div class="question-response both">
                ${question.response_both}
                <p><strong>Alternative Terms:</strong> ${question.alternative_terms}</p>
            </div>

        </div>

        </div>
                  ${index == (jargonQuizQuestions.length - 1) ? `<button class="js-see-results btn__see-results"> See results <span><i class="icon-arrow-right"></i></span></button>`
            :
            `<button class="btn__next-question js-next-question">Next question<span><i class="icon-arrow-right"></i></span></button>`
            }
    </div>

    `
    ).join('')}
`;

const resultsMarkup = `
    ${jargonQuizResults.map((result, index) =>
    `
        <div class="result" stub="${result.stub}">
            <img src="${result.image}" class="result__image">
            <div class="result__content">
              <span class="result__title">${result.title}</span>
              <span class="result__subtitle">${result.subtitle}</span>
              ${result.text}
            </div>
             <div class="results-ctas">
            <div>
                <div class="results-cta">
                        <span class="results-cta__title">What did you think?</span>
                        <span class="results-cta__subtitle">Proud of your result? Share it with your friends!</span>
                        <div class="quiz-share-buttons">
                            <button class="share-facebook"></button>
                            <button class="share-linkedin"></button>
                        </div>
                    </div>
                    <div class="results-cta">
                    <span class="results-cta__title">Want to pick our silly brains
some more?</span>
                        <a data-no-swup href="/thinking-business-to-business-marketing">Take me to the Thinktank!</a>
                    </div>
                </div>
            </div>
        </div>
    `).join('')}
    `;


$('.results .results-container').prepend(resultsMarkup);

$('.questions').append(markup);

$('.progress-bar').append(progressBarContents);
$('.progress-bar__counter > span:last-child').html(jargonQuizQuestions.length);

// ::DEBUG FUNCTION::
// Highlight Answers
// Add visible active state to correct answers (useful for debugging)
function jargonQuizHighlightAnswers() {
    $.each(jargonQuizQuestions, function(i, question) {
        console.log(question.correct_answer);
        var correctAnswer = question.correct_answer;
        $('.question[index='+i+']').find('.answer[index='+correctAnswer+']').addClass('correct');
    });

}
//highlightAnswers();


// When answer is clicked, set temporary answer choice
$('.answer').click(function(){
    jargonQuizSetAnswer($(this));
});


$('.js-see-results').click(function(){
    jargonQuizShowResults();
});


// When user clicks "Submit Answer" button
$('.js-submit-answer').click(function(){
    jargonQuizValidateAnswer($(this));
});

// Show first question by default
$('.question:nth-child(1)').addClass('active');
$('.progress-bar-point:nth-child(1)').addClass('active');


// When user clicks to see the next question
$('.js-next-question').click(function(){
    jargonQuizNextQuestion();
});

function jargonQuizSetAnswer(answer){
    // Find question in questions array
    var $question = $(answer).parents('.question');
    var questionIndex = $question.attr('index');
    var currentQuestion = jargonQuizQuestions[questionIndex];

    // Remove active class from other answers
    $('.answer').removeClass('active');
    $('.answer-container').removeClass('answer-active');
    // Add active class to this answer
    $(answer).addClass('active');
    $(answer).parent().addClass('answer-active');

    // -- EXTRA: FILL IN BLANK SPOT WITH ANSWER --
    // Put word in answer spot
    $question.find('.answer-spot > span.user-answer').html(answer.find('.cased-answer').html());

    // Add class to question to show that answer has been set
    $question.addClass('answer-set');

    // Fade in submit button when answer is set
   // $question.find('.question__submit').fadeIn();

    // Set current_answer property on question object for validation
    currentQuestion.current_answer = answer.attr('index');

    //
    $question.find('.answer-spot').addClass('pop');
    $question.find('.answer-spot').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        $(this).removeClass('pop');
    });
}

function jargonQuizValidateAnswer($answer){
    // Find question DOM element
    var $question = $answer.parents('.question');
    // Get index from DOM element
    var questionIndex = $question.attr('index');
    // Find question in array
    var currentQuestion = jargonQuizQuestions[questionIndex];

    // Get current_answer from question object to be validated
    var currentAnswer = currentQuestion.current_answer;

    // Hide question
    //$question.find('.question__content').hide();
    // Show reponse area
    //$question.find('.question-responses').fadeIn();

    console.log("progres bar node: " + questionIndex);

    var answerStatus = '';

    // -- VALIDATE ANSWER --
    // correct
    if (currentAnswer == currentQuestion.correct_answer){
        currentQuestion.score = 1;
        // Fade in 'correct' response
        $question.addClass('is-correct');
        $('.progress-bar-point:nth-child('+(parseInt(questionIndex) + 1)+')').addClass('is-correct');
        answerStatus = 'Correct';
        //$question.find('.question-response.correct').fadeIn();
    // incorrect
    } else {
        // Fade in 'wrong' response
        $question.addClass('is-wrong');
        $('.progress-bar-point:nth-child('+(parseInt(questionIndex) + 1)+')').addClass('is-wrong');
        answerStatus = 'Incorrect';
        //$question.find('.question-response.wrong').fadeIn();
        currentQuestion.score = 0;
    }

    // Add score to questions
    jargonQuizSettings.current_score = jargonQuizSettings.current_score + currentQuestion.score;

    console.log(currentQuestion);

    $question.addClass('is-answered');

    // Fade in 'both' response
    $question.find('.question-response.both').fadeIn();

    // Update quiz score
    jargonQuizUpdateOverallScore();

    // Data layer pushin'
    dataLayerPush(jargonQuizSettings.quiz_name,
        (parseInt(questionIndex)+1), // Offset array 0
        (currentQuestion.question).substring(0,40),
        "Multiple Choice",
        currentQuestion.answers[currentAnswer].letter,
        answerStatus);
}

// Function to tally up score from all questions
function jargonQuizUpdateOverallScore(){
    console.log("Current score: " + jargonQuizSettings.current_score);
    $('.js-quiz-score').html(jargonQuizSettings.current_score);
}

function jargonQuizNextQuestion(){
    var currentQuestion = $('.question.active');
    var questions = $('.questions').children();
    var nextQuestion = currentQuestion.next();

    // Update current question in quiz
    jargonQuizSettings.current_question++;
    //console.log("current question:"+jargonQuizSettings.current_question);
    $('.progress-bar__counter > span:first-child').html(jargonQuizSettings.current_question);
    // Get index of current question
    var questionIndex = (parseInt(currentQuestion.attr('index')) + 1);
    //console.log(questionIndex);
    // Send index of current question to progress bar
    jargonQuizUpdateProgressBar(questionIndex);


    if (nextQuestion.length){
        currentQuestion.removeClass('active');
        nextQuestion.addClass('active');
    } else {

    }
}

function jargonQuizUpdateProgressBar(progressNum){
    $('.progress-bar').attr('progress', progressNum);
    $('.progress-bar-point:nth-child('+(progressNum + 1)+')').addClass('active');
}

function jargonQuizShowResults(){
    $('.questions').removeClass('visible');
    $('.results').addClass('visible');

    $('.quiz-wrapper').addClass('is-showing-results');

    var currentScore = jargonQuizSettings.current_score;
    $.each(jargonQuizResults, function(i, result) {
        var resultRequiredScore = result.required_score;
        // console.log(question.score);
        if (resultRequiredScore.includes(currentScore)){
            $('.result[stub='+result.stub+']').fadeIn();
            initShareButtons(result.share_message);
            return;
        }
    });
}

function initShareButtons(resultMessage){
    // Social

    var documentURL = document.URL.replace(/\/$/, '');
    var twitterShareURL = 'https://goo.gl/A4dgNj';
    var facebookShareURL = 'https://goo.gl/sAnXwo';
    var linkedinShareURL = 'https://goo.gl/Lau9Zt';


    // $('.share-twitter').sharrre({
    //     text: resultMessage + " Test out your marketing jargon vocabulary at",
    //     url: twitterShareURL,
    //     share: {
    //         twitter: true
    //     },
    //     enableHover: false,
    //     enableTracking: true,
    //     template: '<i class="icon-quiz-social-twitter"></i>',
    //     buttons: { twitter: {}},
    //     click: function(api, options){
    //         api.simulateClick();
    //         api.openPopup('twitter');
    //     }
    // });

    // Facebook
    // $('.share-facebook').sharrre({
    //     text: resultMessage + " Test out your marketing jargon vocabulary at",
    //     url: facebookShareURL,
    //     share: {
    //         facebook: true
    //     },
    //     enableHover: false,
    //     enableTracking: true,
    //     template: '<i class="icon-quiz-social-facebook"></i>',
    //     buttons: { facebook: {}},
    //     click: function(api, options){
    //         api.simulateClick();
    //         api.openPopup('facebook');
    //     }
    // });

    $('.promoted-quiz .share-linkedin').prepend('<a href="http://www.linkedin.com/shareArticle?mini=true&url='+linkedinShareURL+'&title='+"Test your marketing jargon vocabulary"+'&summary='+resultMessage + " Test out your marketing jargon vocabulary."+'&source='+documentURL+'"><i class="icon-quiz-social-linkedin"></i></a>');

    $('.share-linkedin a').on("click", function(e) {
        $(this).customerPopup(e);
    });
}


$('.js-start-quiz').click(function(){
    console.log('clicked 2')
    $('body').addClass('quiz-visible');
});

$('.js-close-quiz').click(function(){
    $('body').removeClass('quiz-visible');
});

var documentURL = document.URL.replace(/\/$/, '');
if (document.title) {
    var documentTitle = document.title.replace('|', ' - ');
}
if (document.head.querySelector("[name=description]")){
    var documentDescription = document.head.querySelector("[name=description]").content;
}

function dataLayerPush(quizName, questionNumber, questionText, questionType, userResponse, correctOrIncorrect){
    console.log(questionText);
    console.log("Pushing datalayer");
    var dataLayer = window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'Quiz',
        'quizName': quizName,
        'quizQuestionNum': questionNumber,
        'quizQuestionText': questionText,
        'quizQuestionType': questionType,
        'quizQuestionResponse': userResponse,
        'quizQuestionResult': correctOrIncorrect
    });
}

} else if (document.getElementsByClassName('quiz-wrapper').length && document.getElementsByClassName('multiple-choice-quiz').length) {

console.log("multiple choice quiz js loaded")

// Multiple Choice Quiz

var mcQuizSettings = {
        "quiz_name": "Whats your marketing dating profile? Quiz",
        "current_question": 1,
        "current_score": 0,
        "answers": [] };
    
    var mcQuizResults = [
        {
            "stub": "disruptor",
            "title": "You're a Disruptor!",
            "subtitle": "You reject the status quo!",
            "image": "/dist/images/interface/buzzword-quiz/result_disruptor.gif",
            "text": "<p>You didnâ€™t get very many correct answers, but youâ€™re a winner in our books. If weâ€™re being honest, youâ€™re much better off excluding these terms from your marketing vocabulary. </p><p>After all, thereâ€™s one big issue underlying all of these marketing terms â€” besides how silly they might sound or look on paper â€” and itâ€™s one of communication. What do these terms really mean? What value do they add to your content, your reports, or even your internal discussions?</p><p>Even with the best intentions, bad marketing jargon can come across as unspecific and hollow, obscuring the core of your message and alienating your audience.</p><p><strong>Tips for Disruptors:</strong> You can use that rebellious attitude to your advantage. Your marketing lexicon is a guideline, not a rule, so focus on using a varied vocabulary and play to your creative strengths.</p>",
            "share_message": "I'm a buzzword Disruptor!",
            "required_score": [0, 1, 2] },
    
        {
            "stub": "sherpa",
            "title": " Youâ€™re a Sherpa!",
            "subtitle": "Like a wise Sherpa guiding your followers through the Himalayas, you know your way around a quiz.",
            "image": "/dist/images/interface/buzzword-quiz/result_sherpa.gif",
            "text": "<p>You did pretty well, but you havenâ€™t fully assimilated into the world of marketing jargon. And we donâ€™t blame you! </p><p>After all, thereâ€™s one big issue underlying all of these marketing terms â€” besides how silly they might sound or look on paper â€” and itâ€™s one of communication. What do these terms really mean? What value do they add to your content, your reports, or even your internal discussions?</p><p>Even with the best intentions, bad marketing jargon can come across as unspecific and hollow, obscuring the core of your message and alienating your audience.</p><p><strong>Tips for Sherpas:</strong> You still have the chance to stray from the flock (in a good way). If you can balance specific language with outside-the-box thinking, youâ€™ll be well on your way to creating more valuable and engaging content.</p>",
            "share_message": "I'm a buzzword Sherpa!",
            "required_score": [3, 4, 5] },
    
        {
            "stub": "envisioneer",
            "title": "Youâ€™re an Envisioneer!",
            "subtitle": "Welcome to the Machine.",
            "image": "/dist/images/interface/buzzword-quiz/result_envisioneer.gif",
            "text": "<p>Youâ€™re a full-blown Envisioneer, ready to ideate holistic innovations til the cows come home! Though weâ€™re proud of you for being so well-versed in modern marketing lingo, we encourage you to use that creative mind for good instead of evil. </p><p>After all, thereâ€™s one big issue underlying all of these marketing terms â€” besides how silly they might sound or look on paper â€” and itâ€™s one of communication. What do these terms really mean? What value do they add to your content, your reports, or even your internal discussions?</p><p>Even with the best intentions, bad marketing jargon can come across as unspecific and hollow, obscuring the core of your message and alienating your audience.</p><p><strong>Tips for Envisioneers:</strong> Do you say â€œinnovativeâ€ a lot, or struggle to find synonyms for â€œsolutionsâ€? Find your go-to words and challenge yourself to write content without using them at all. You might find that your content gets more descriptive, and more valuable to readers, as a result.</p>",
            "share_message": "I'm a buzzword Envisioneer!",
            "required_score": [6, 7] }];
    
    // ::DEBUG FUNCTION::
    // Highlight Answers
    // Add visible active state to correct answers (useful for debugging)
    function mcQuizHighlightAnswers() {
        $.each(questions, function (i, question) {
            console.log(question.correct_answer);
            var correctAnswer = question.correct_answer;
            $('.question[index=' + i + ']').find('.answer[index=' + correctAnswer + ']').addClass('correct');
        });
    
    }
    //highlightAnswers();
    
    // When answer is clicked, set temporary answer choice
    $('.js-answer-question').click(function () {
        mcQuizValidateAnswer($(this));
    });
    
    
    $('.js-see-results').click(function () {
        mcQuizValidateAnswer($(this));
        mcQuizShowResults();
    });
    
    
    // When user clicks "Submit Answer" button
    $('.js-submit-answer').click(function () {
    
    });
    
    // Show first question by default
    $('.question:nth-child(1)').addClass('active');
    $('.progress-bar-point:nth-child(1)').addClass('active');
    
    
    // When user clicks to see the next question
    $('.js-next-question').click(function () {
        mcQuizNextQuestion();
    });
    
    function mcQuizSetAnswer(answer) {
        // Find question in questions array
        var $question = $(answer).parents('.question');
        var questionIndex = $question.attr('index');
        var currentQuestion = questions[questionIndex];
    
        // Remove active class from other answers
        $('.answer').removeClass('active');
        $('.answer-container').removeClass('answer-active');
        // Add active class to this answer
        $(answer).addClass('active');
        $(answer).parent().addClass('answer-active');
    
        // -- EXTRA: FILL IN BLANK SPOT WITH ANSWER --
        // Put word in answer spot
        $question.find('.answer-spot > span.user-answer').html(answer.find('.cased-answer').html());
    
        // Add class to question to show that answer has been set
        $question.addClass('answer-set');
    
        // Fade in submit button when answer is set
        // $question.find('.question__submit').fadeIn();
    
        // Set current_answer property on question object for validation
        currentQuestion.current_answer = answer.attr('index');
    
        //
        $question.find('.answer-spot').addClass('pop');
        $question.find('.answer-spot').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
            $(this).removeClass('pop');
        });
    
    }
    
    function mcQuizValidateAnswer(answer) {
        var $answer = $(answer);
    
        var resultPoint = parseInt($answer.attr('target-result'));
        mcQuizSettings.answers.push(resultPoint);
        console.log("Answers:");
        console.log(mcQuizSettings.answers);
    
        // // Find question DOM element
        var $question = $answer.parents('.question');
        // // Get index from DOM element
        var questionIndex = $question.attr('index');
    
        var questionText = $question.find('.question__title').text();
    
        var answerText = $answer.find('span').text();
    
    
        var answerIndex = $answer.parent().index();
        var answerLetter = '';
    
        if (answerIndex == 0) {
            answerLetter = 'A';
        } else if (answerIndex == 1) {
            answerLetter = 'B';
        } else if (answerIndex == 2) {
            answerLetter = 'C';
        } else if (answerIndex == 3) {
            answerLetter = 'D';
        } else if (answerIndex == 4) {
            answerLetter = 'E';
        } else if (answerIndex == 5) {
            answerLetter = 'F';
        }
    
        // Data layer pushin'
        dataLayerPush(mcQuizSettings.quiz_name,
            parseInt(questionIndex), // Offset array 0
            questionText.substring(0, 40),
            "Multiple Choice",
            answerLetter + ' - ' + answerText);
    
        mcQuizNextQuestion();
    }
    
    // Function to tally up score from all questions
    function mcQuizUpdateOverallScore() {
        console.log("Current score: " + mcQuizSettings.current_score);
        $('.js-quiz-score').html(mcQuizSettings.current_score);
    }
    
    
    function mcQuizNextQuestion() {
        var currentQuestion = $('.question.active');
        var questions = $('.questions').children();
        var nextQuestion = currentQuestion.next();
    
        // Update current question in quiz
        mcQuizSettings.current_question++;
        //console.log("current question:"+mcQuizSettings.current_question);
        $('.progress-bar__counter > span:first-child').html(mcQuizSettings.current_question);
        // Get index of current question
        var questionIndex = parseInt(currentQuestion.attr('index'));
        //console.log(questionIndex);
        // Send index of current question to progress bar
        mcQuizUpdateProgressBar(questionIndex);
    
    
        if (nextQuestion.length) {
            currentQuestion.removeClass('active');
            nextQuestion.addClass('active');
        } else {
    
        }
    }
    
    function mcQuizUpdateProgressBar(progressNum) {
        $('.progress-bar').attr('progress', progressNum);
        $('.progress-bar-point:nth-child(' + progressNum + ')').addClass('active');
    }
    
    
    function reduceArray(array) {
        var mf = 1;
        var m = 0;
        var item = void 0;
        for (var i = 0; i < array.length; i++)
        {
            for (var j = i; j < array.length; j++)
            {
                if (array[i] == array[j])
                    m++;
                if (mf < m)
                {
                    mf = m;
                    item = array[i];
                }
            }
            m = 0;
        }
    
        return item;
    }
    
    
    function mcQuizShowResults() {
        $('.questions').removeClass('visible');
        $('.results').addClass('visible');
    
        $('.quiz-wrapper').addClass('is-showing-results');
    
    
        var uniqueAnswers = [];
    
        var answersArray = mcQuizSettings.answers;
    
        var resultOne = reduceArray(answersArray);
    
    
        $('.result[index=' + resultOne + ']').fadeIn();
    
        // console.log(item);
        // console.log(mf + ' times')
    
        var currentScore = mcQuizSettings.current_score;
        $.each(mcQuizResults, function (i, result) {
            var resultRequiredScore = result.required_score;
            // console.log(question.score);
            if (resultRequiredScore.includes(currentScore)) {
                $('.result[stub=' + result.stub + ']').fadeIn();
                initShareButtons(result.share_message);
                return;
            }
        });
    }
    
    function initShareButtons(resultMessage) {
        // Social
    
        // var documentURL = document.URL.replace(/\/$/, '');
        // var twitterShareURL = 'https://goo.gl/A4dgNj';
        // var facebookShareURL = 'https://goo.gl/sAnXwo';
        // var linkedinShareURL = 'https://goo.gl/Lau9Zt';
    
    
        // $('.share-twitter').sharrre({
        //     text: resultMessage + " Test out your marketing jargon vocabulary at",
        //     url: twitterShareURL ,
        //     share: {
        //         twitter: true
        //     },
        //     enableHover: false,
        //     enableTracking: true,
        //     template: '<i class="icon-quiz-social-twitter"></i>',
        //     buttons: { twitter: {}},
        //     click: function(api, options){
        //         api.simulateClick();
        //         api.openPopup('twitter');
        //     }
        // });
    
        // // Facebook
        // $('.share-facebook').sharrre({
        //     text: resultMessage + " Test out your marketing jargon vocabulary at",
        //     url: facebookShareURL,
        //     share: {
        //         facebook: true
        //     },
        //     enableHover: false,
        //     enableTracking: true,
        //     template: '<i class="icon-quiz-social-facebook"></i>',
        //     buttons: { facebook: {}},
        //     click: function(api, options){
        //         api.simulateClick();
        //         api.openPopup('facebook');
        //     }
        // });
        //
        //
        //
        //
        // $('.share-linkedin').prepend('<a href="http://www.linkedin.com/shareArticle?mini=true&url='+linkedinShareURL+'&title='+"Test your marketing jargon vocabulary"+'&summary='+resultMessage + " Test out your marketing jargon vocabulary."+'&source='+documentURL+'"><i class="icon-quiz-social-linkedin"></i></a>');
        //
        // $('.share-linkedin a').on("click", function(e) {
        //     $(this).customerPopup(e);
        // });
    }
    
    $('.js-start-quiz').click(function () {
        console.log('clicked')
        $('body').addClass('quiz-visible');
    });
    
    $('.js-close-quiz').click(function () {
        $('body').removeClass('quiz-visible');
    });
    
    var documentURL = document.URL.replace(/\/$/, '');
    if (document.title) {
        var documentTitle = document.title.replace('|', ' - ');
    }
    if (document.head.querySelector("[name=description]")) {
        var documentDescription = document.head.querySelector("[name=description]").content;
    }
    
    function dataLayerPush(quizName, questionNumber, questionText, questionType, userResponse, correctOrIncorrect) {
        console.log(questionText);
        console.log("Pushing datalayer");
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'Quiz',
            'quizName': quizName,
            'quizQuestionNum': questionNumber,
            'quizQuestionText': questionText,
            'quizQuestionType': questionType,
            'quizQuestionResponse': userResponse });
    
        console.log(dataLayer);
    }
}

// Thinking homepage

if (document.getElementsByClassName('blog-header').length) {
    $(window).scroll(function() {
        console.log('scroll')
        $blogHeader = $('.blog-header');
        $blogHeaderHeight = $blogHeader.outerHeight();
        var scrolledY = $(window).scrollTop();
        if (scrolledY >= 0){
            $blogHeader.css('background-position-y', ((scrolledY)) + 'px');
        }

        $blogHeader.find('.fade').css('opacity', ((scrolledY / 3) / $blogHeaderHeight) + .7);
        $blogHeader.find('.blog-header__content').css('filter', 'blur('+(scrolledY / 3) / $blogHeaderHeight+')');
    });
}

// Contact page
if (document.getElementById('contactUs')) {
    var formID = 'contactUs';
    console.log('formId', formID)
    var formElement = $('#contactUs');
    var formIsValid = false;
    /* Act-On Form Information */
    //http://a9952.actonsoftware.com/acton/form/9952/001d:d-0001/0/-/-/-/-/index.htm
    http://[server]/acton/form/[aid]/[fid]:[did]/0/index.htm
        var aoProtocol = location.protocol;
    if ( aoProtocol.indexOf('http') < 0 ) aoProtocol = 'http:';
    var aoCAP = {
        aid: '9952',
        fid: '001d',
        did: 'd-0001',
        server: 'a9952.actonsoftware.com',
        formId: formID,
        protocol: aoProtocol
    };
    var aoArr = aoArr || []; aoArr.push(aoCAP);
    /* --------- */
    // If form is valid, set variable so Act-On script can do its job
    // formElement.validator().on('submit', function (e) {
    //     if (e.isDefaultPrevented()) {
    //         formIsValid = false;
    //     } else {
    //         formIsValid = true;
    //     }
    // });
    function AoProcessForm(formelement) {
        for (AoI = 0; AoI < aoArr.length; AoI++) {
            if ( aoArr[AoI].aid && aoArr[AoI].fid && aoArr[AoI].did && aoArr[AoI].server && ( aoArr[AoI].formId || aoArr[AoI].formName )) {
                var d = document,
                    thisFormId = formelement.id || '',
                    thisFormName = formelement.name || '',
                    bi = function(i) {
                        return d.getElementById(i)
                    },
                    bn = function(i) {
                        return d.getElementsByName(i)[0]
                    },
                    names = [],
                    values = [],
                    params = {},
                    w = window,
                    targetIdOrName = aoArr[AoI].formName ? bn(aoArr[AoI].formName) : bi(aoArr[AoI].formId),
                    len = targetIdOrName.elements.length,
                    isLoaded = false,
                    ud = 'undefined',
                    st = function(f, i) {
                        w.setTimeout(f, i)
                    },
                    ce = function(t) {
                        return d.createElement(t)
                    },
                    gid = function(p) {
                        var j, i = 0,
                            n = Math.random,
                            r = [],
                            c = '0123456789abcdef'.split('');
                        for (; i < 16; i++) r[i] = c[(0 | n() * 16) & 0xf];
                        j = p + r.join('');
                        return bi(j) == null ? j : gid(p);
                    },
                    addInput = function( form, name, value )
                    {
                        var el = ce('input');
                        el.name = name;
                        el.value = value;
                        form.appendChild( el );
                    },
                    idifr = gid('aoCapT');
                if (aoArr[AoI].formName == thisFormName || aoArr[AoI].formId == thisFormId) {
                    var dTarget = ce('div');
                    dTarget.style.display = 'none';
                    d.body.appendChild(dTarget);
                    dTarget.innerHTML = '<iframe name="' + idifr + '" id="' + idifr + '"><\/iframe>'; // generate iframe
                    var dForm = ce('form'), idform = gid('aoCapD');
                    dForm.id = idform;
                    dForm.style.display = "none";
                    dForm.method = 'POST';
                    dForm.enctype = 'multipart/form-data';
                    dForm.acceptCharset = 'UTF-8';
                    dForm.target = idifr; // form targets iframe
                    dForm.action = (aoCAP.protocol || w.location.protocol) + '//' + aoCAP.server + '/acton/forms/userSubmit.jsp';
                    d.body.appendChild(dForm); // generate form
                    for (i = 0; i < len; i++) {
                        var el = targetIdOrName.elements[i];
                        var name = typeof(el.name) != ud ? el.name : null;
                        var value = typeof(el.value) != ud ? el.value : null;
                        tagName = el.nodeName.toLowerCase();
                        if (tagName == 'input' && (el.type == 'radio' || el.type == 'checkbox') && !el.checked) {
                            name = null;
                        } else if (tagName == 'select' && el.selectedIndex && el.selectedIndex != -1 && el.options[el.selectedIndex] && el.options[el.selectedIndex].value)
                        {
                            value = el.options[el.selectedIndex].value
                        };
                        if (name != null && name != '') {
                            names.push(name);
                            values.push(el.value);
                            console.log("Element name: " + el.name + " / Element value: " + el.value);
                            params[name] = el.value;
                        };
                        addInput( dForm, el.name, el.value );
                    }
                    aoCAP.pid = 0;
                    aoCAP.cuid = aoCAP.cuid || '';
                    aoCAP.srcid = aoCAP.srcid || '';
                    aoCAP.camp = aoCAP.camp || '';
                    addInput( dForm, 'ao_a', aoArr[AoI].aid );
                    addInput( dForm, 'ao_f', aoArr[AoI].fid );
                    addInput( dForm, 'ao_d', aoArr[AoI].fid+":"+aoArr[AoI].did );
                    addInput( dForm, 'ao_p', 0 );
                    addInput( dForm, 'ao_jstzo', new Date().getTimezoneOffset() );
                    addInput( dForm, 'ao_form_neg_cap', '' );
                    addInput( dForm, 'ao_refurl', d.referrer );
                    addInput( dForm, 'ao_cuid', aoCAP.cuid );
                    addInput( dForm, 'ao_srcid', aoCAP.srcid );
                    addInput( dForm, 'ao_camp', aoCAP.camp );
                    bi(idform).submit();
                    var dTargetFrame = bi( idifr );
                    dTargetFrame.onload = function() {
                        isLoaded = true;
                    };
                    var waitForSubmit = function()
                    {
                        this.count = "";
                        if ( ! ( isLoaded || dTargetFrame.readyState == "complete" ) ) {
                            st( waitForSubmit, 200 );
                            this.count ++;
                        } else if (this.count > 7) {
                            return true;
                            console.log("skipping dForm");
                        }
                        else {
                            d.body.removeChild( dForm );
                            d.body.removeChild( dTarget );
                        }
                    };
                    st( waitForSubmit, 100 );
                }
            } else {
                console.log('aoCAP property missing');
            }
        }
    };
    document.getElementById(formID).addEventListener("submit", function(evt) {
        //alert('test');
        evt.preventDefault();
        //evaluate radio buttons and post only if checked
        var radio_btns = document.querySelectorAll("input[type='radio']");
        for(var i = 0; i < radio_btns.length; i++){
            if(radio_btns[i].checked == false){
                radio_btns[i].setAttribute("name", "");
            };
        };
        //evaluate checkboxes and post only if checked
        var chk_bxs = document.querySelectorAll("input[type='checkbox']");
        for(var i = 0; i < chk_bxs.length; i++){
            if(chk_bxs[i].checked == false){
                chk_bxs[i].setAttribute("name", "");
            };
        };
        //if (formIsValid){
        console.log("Submitting form!");
        setTimeout(AoProcessForm(this), 0);
        setTimeout(function(){
            window.location.replace("/contact/newsletter-thank-you");
        }, 1000);
//                     } else {
//                         alert("Form invalid. Not submitted");
//                     }
    }, true);
}